import React , {useEffect} from 'react';
import Aos from 'aos';
import "aos/dist/aos.css";


const MostFunctionality = () => {

  useEffect(() => {
    Aos.init( {  duration: 1200 } )
  } , []);


  return (
    <div className="section most_features_section container-mid">

    <div className="d-flex-c" data-aos="fade-right" data-aos-delay="30" data-aos-easing="ease" data-aos-mirror="true" >

<div className="info_box"></div>
<h1 className="main_headline"> أهم المميزات</h1>
</div>

    <div className="d-flex-c f-sp f-wrap features_icons section">

      <div className="single_feature_div" data-aos="zoom-in" data-aos-duration="260"   data-aos-easing="ease-in-quad" data-aos-mirror="true" >
        <img src="https://cdn-icons-png.flaticon.com/512/717/717498.png" alt="" />
        <h1 className="headline_feaure_info">خريطة تفاعلية 3D </h1>
      </div>

      <div className="single_feature_div" data-aos="zoom-in" data-aos-duration="290"   data-aos-easing="ease-in-quad" data-aos-mirror="true" >
        <img src="https://cdn-icons-png.flaticon.com/512/9150/9150506.png" alt="" />
        <h1 className="headline_feaure_info"> حجز بكج لمكانك المفضل </h1>
      </div>

      <div className="single_feature_div" data-aos="zoom-in" data-aos-duration="320"   data-aos-easing="ease-in-quad" data-aos-mirror="true" >
        <img src="https://cdn-icons-png.flaticon.com/512/7566/7566278.png" alt="" />
        <h1 className="headline_feaure_info"> وجهات لابرز معالم جازان </h1>
      </div>

    </div>

    </div>
  )
}

export default MostFunctionality